import { render, staticRenderFns } from "./reservations.vue?vue&type=template&id=51d551de&scoped=true"
import script from "./reservations.vue?vue&type=script&lang=js"
export * from "./reservations.vue?vue&type=script&lang=js"
import style0 from "./reservations.vue?vue&type=style&index=0&id=51d551de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d551de",
  null
  
)

export default component.exports